import { client } from 'app/api/_client';
import { Endpoints } from 'app/api/helpers';
import { ReverseSummaryPdfRequest } from '@lenderful/domain';

export const postEmailReverseSummary = (request: ReverseSummaryPdfRequest) => {
  return client
    .post(Endpoints.REVERSE_SUMMARY, { ...request })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};
